import {Component} from '@angular/core';
import {ModalController, NavParams} from '@ionic/angular';
import {Order} from "../../models/order";
import {OrderService} from "../../services/order.service";
import {Driver} from "../../models/driver";

@Component({
    selector: 'emc-data-modal',
    template: `
            <ion-content>
                <div style="padding: 1em;">
                    <div *ngFor="let d of drivers;" style="padding: 0.2em; cursor: pointer; font-size: 1.2em; margin: 0.2em; border: ridge 0.1em gray; border-radius: 0.2em;" (click)="selectDriver(d)">
                        {{d.name}}
                        <span style="color: lightgray; float: right; margin-right: 0.5em;"> ></span>
                    </div>
                </div>
            </ion-content>
    `
})
export class DriversModalComponent {

    drivers: any;
    order: Order;

    constructor(public viewCtrl: ModalController, params: NavParams, private orderService: OrderService) {
        const drivers = params.get('drivers');
        drivers.sort((a, b) => {
            const x = a.name.toLowerCase();
            const y = b.name.toLowerCase();
            if (x < y) { return -1; }
            if (x > y) { return 1; }
            return 0;
        });
        drivers.unshift({name: 'NONE'});
        this.drivers = drivers;
        this.order = params.get('order');
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }

    selectDriver(driver: Driver) {
        this.order.driver = driver.name === 'NONE' ? null : driver;
        this.orderService.updateOrder(this.order);
    }

}
